export const USER_SUCCESS_REGISTER = "user register successful"
export const USER_FAILURE_REGISTER = "user register failure"
export const USER_NOTIFICATION = "user notification"
export const ADD_NOTIFICATION = "add notification"
/// login
export const USER_LOGIN_SUCCESSFUL = "user login successful"
export const USER_LOGIN_FAILURE ="user login failure"
//logout
export const USER_LOGOUT = "user logout"
// user
export const GET_USER_DETAILS = "get user details"
//// blogs
export const GET_BLOGS_OF_USER = "get all blogs of user"
export const GET_CATE_BLOG = "get cate blog"
export const GET_BLOG = "get blog"
export const GET_BY_ID_BLOG = "get by id blog"
export const GET_BLOG_BY_SEARCH_NAME = "get blog by search name"
/// delete, insert, update
export const ADD_BLOG = "add blog"
export const UPDATE_BLOG = "update blog"
export const DELETE_BLOG = "delete blog"
//// comment
export const ADD_COMMENT = "add comment"
//// Home
export const GET_TRENDING_BLOG = "trending blog"
export const UPDATE_TRENDING_BLOG = "update trending blog"
export const GET_TOP_LOVE = "get top love "
export const GET_RECOMMEND = "get recommend"
//// others
export const LOADING_TOGGLE = "loading toggle"
///loved
export const GET_BLOGS_LOVED = "get blog loved"
/// GET IMAGE
export const GET_IMAGE = "get image"
export const UPLOAD_IMAGE = "upload image"
/// GET TYPE
export const GET_TYPE = "get type"
export const GET_TYPE_BY_LEVEL = "get type by level"
/// admin
export const GET_USERS = "get all user"
export const GET_BLOGS = "get all blogs" 